import React from 'react'
import { ResumeWidget } from '../../../../common/components'
import { Col, Row } from '../../../../common/lib'
import { ArticleFeedback, TradeBoxNew } from '../../components'
import Sidebar from '../../components/Sidebar'

// const etoroRegex =  /trading-platforms-nigeria|trading-platforms-mexico|part-time-forex|trading-platforms-south-africa|bond-brokers|fixed-rate-bonds|stock-brokers-mexico|stock-brokers-nigeria|commission-free-trading-apps-uk/
const pepperstoneRegex = new RegExp(
  [
    'bond-brokers',
    'how-to-trade-cryptocurrency',
    'places-to-buy-bitcoin',
    'best-cryptocurrency-exchanges',
    'top-commodities-to-trade',
    'should-i-buy-bitcoin',
    'buy-bitcoin-as-a-company',
    'places-to-buy-cryptocurrency',
    'bitcoin-faucets',
    'options-brokers',
    'ethereum-mining',
  ].join('|'),
)
const ArticleSidebar = ({ article, location, tokens }) => {
  const isValidPathToShowTradeBox = () => {
    return (
      location.pathname.match('/trading') &&
      !location.pathname.match(pepperstoneRegex)
    )
  }
  return (
    <Col className="sidebar" md={4} lg={3}>
      {isValidPathToShowTradeBox() && (
        <TradeBoxNew
          heroUrl={article.heroButtonUrl}
          heroDisclaimer={article.heroDisclaimer}
          slug={article.slug}
          site="wiki"
        />
      )}
      <Row>
        {article.disableAds && (
          <Col>
            <div
              {...{
                className: 'mediavineAdsTop', // TODO: fixed class for Mediavine, don't change
                id: 'mediavineAdsTop', // TODO: fixed id for Mediavine, don't change
              }}
            />
          </Col>
        )}
      </Row>
      <Row>
        {article.disableAds && (
          <Col>
            <div
              {...{
                className: 'mediavineAdsBottom', // TODO: fixed class for Mediavine, don't change
                id: 'mediavineAdsBottom', // TODO: fixed id for Mediavine, don't change
              }}
            />
          </Col>
        )}
      </Row>
      {(article.showJtpBuyBox && !location.pathname.match('/trading')) ||
        location.pathname.match('/aptitude-tests')
        ? null
        : null}
      {!location.pathname.match('trading') &&
        !location.pathname.match('/aptitude-tests') &&
        !article.showJtpBuyBox && (
          <>
            <div className="w-100">
              <Sidebar tokens={tokens} />
            </div>
            {/* <ResumeWidget slug={article.slug} /> */}
            {/* Was this article helpful component */}
            {/* <ArticleFeedback /> */}
          </>
        )}
    </Col>
  )
}

export default ArticleSidebar
